import { Col, Row } from "antd";
import { get, isEmpty, set } from "lodash";
import { useTranslation } from "react-i18next";

import Form from "shared/components/Form";
import Input from "shared/components/Input";
import { NAME_SPACES } from "shared/locales/constants";
import { SUBSCRIPTION_FORM_KEYS } from "utils/constants";

const MarketingConsents = ({ setPercent, initialValues, errors }) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.CONTRACT);
  const SUBSCRIPTION = t("SUBSCRIPTION", { returnObjects: true });
  const DIGITAL_OPTION = t("SUBSCRIPTION.FORM.DIGITAL_OPTION.MUTUAL_MOBILITY", {
    returnObjects: true,
  });

  return (
    <div
      className="subscription-form--wrapper"
      id={`${SUBSCRIPTION_FORM_KEYS.ADDITIONAL_INFORMATION.MARKETING_CONSENTS}-section`}
    >
      <Form
        type="vertical"
        title={
          SUBSCRIPTION.FORM.ADDITIONAL_INFORMATION.MARKETING_CONSENTS.TITLE
        }
      >
        <Row gutter={[16, 16]}>
          <Col lg={24} xs={24}>
            <Input
              type="switch"
              label={DIGITAL_OPTION.EMAIL_OFFERS_OPT_IN}
              defaultChecked={get(
                initialValues,
                "project.contact.fields.acceptEmailOffers",
              )}
              errors={errors["project.contact.fields.acceptEmailOffers"]}
              touched={
                !isEmpty(errors["project.contact.fields.acceptEmailOffers"]) ||
                get(
                  initialValues,
                  "project.contact.fields.acceptEmailOffers",
                ) === false
              }
              onChange={(value) => {
                set(
                  initialValues,
                  "project.contact.fields.acceptEmailOffers",
                  value,
                );
                setPercent(initialValues);
              }}
            />
          </Col>

          <Col lg={24} xs={24}>
            <Input
              type="switch"
              label={DIGITAL_OPTION.SMS_OFFERS_OPT_IN}
              defaultChecked={get(
                initialValues,
                "project.contact.fields.acceptSMSOffers",
              )}
              errors={errors["project.contact.fields.acceptSMSOffers"]}
              touched={
                !isEmpty(errors["project.contact.fields.acceptSMSOffers"]) ||
                get(initialValues, "project.contact.fields.acceptSMSOffers") ===
                  false
              }
              onChange={(value) => {
                set(
                  initialValues,
                  "project.contact.fields.acceptSMSOffers",
                  value,
                );
                setPercent(initialValues);
              }}
            />
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default MarketingConsents;
